import type { CustomElementManifest } from './manifest.ts';

type SearchRoot = Document | Element;

const loadingCustomElements = new Set<string>();

function rootContainsTag(root: SearchRoot, tag: string): boolean {
  return (
    (root instanceof Element && root.matches(tag)) ||
    root.querySelector(tag) !== null
  );
}

export function loadCustomElements(
  manifest: CustomElementManifest,
  root: SearchRoot = document
): void {
  for (const [tag, loadModule] of Object.entries(manifest)) {
    if (
      loadingCustomElements.has(tag) ||
      window.customElements.get(tag) ||
      !rootContainsTag(root, tag)
    ) {
      continue;
    }

    loadingCustomElements.add(tag);

    loadModule()
      .catch((error) => {
        console.error(`Could not load code for <${tag}>.`, error);
      })
      .finally(() => {
        loadingCustomElements.delete(tag);
      });
  }
}
